import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { useEffect, useState } from 'react';
import { useTranslation, Language } from '@/utils/translations';

interface QuestionCardProps {
  question: string;
  onAnswer: (answer: boolean) => void;
  progress: number;
}

export const QuestionCard = ({ question, onAnswer, progress }: QuestionCardProps) => {
  const [currentLang, setCurrentLang] = useState<Language>('en');
  
  useEffect(() => {
    const savedLang = localStorage.getItem('preferredLanguage') as Language;
    if (savedLang) {
      setCurrentLang(savedLang);
    }
  }, []);

  const t = useTranslation(currentLang);

  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      className="flex flex-col items-center justify-center min-h-screen p-4"
    >
      <div className="w-full max-w-md mb-8">
        <div className="progress-bar">
          <div className="progress-bar-fill" style={{ width: `${progress}%` }} />
        </div>
      </div>

      <div className="question-card">
        <h2 className="text-xl font-semibold mb-8 text-center">{question}</h2>
        
        <div className="grid grid-cols-2 gap-4">
          <Button
            onClick={() => onAnswer(true)}
            variant="outline"
            className="w-full"
          >
            {t('yes')}
          </Button>
          <Button
            onClick={() => onAnswer(false)}
            variant="outline"
            className="w-full"
          >
            {t('no')}
          </Button>
        </div>
      </div>
    </motion.div>
  );
};